// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const eligibility = {
  eligibility_section: {
    landing_description:
      'ALEX在这里帮助您确定哪个计划最适合您和您的家人!但是,这不是一个注册平台;我们会在体验结束时引导您前往注册网站。在注册之前,您应该全面审阅所有福利文件。您对这些问题的回答是匿名的。',
    terms_title: '服务条款',
    survey_tokens: {
      zipCode: '您的5位数邮政编码是什么?',
      employment: '您是全职还是兼职?',
    },
    privacy_policy: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '最后修改日期:2019年11月8日',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Picwell, Inc.,一家特拉华州公司("Picwell"、"我们"或"我方")尊重您的隐私,并致力于通过遵守本隐私政策("政策")来保护您的隐私。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本政策描述了我们可能从您处收集的信息类型,或您在使用Picwell福利计划选择和决策支持服务("服务")时可能提供的信息类型,以及我们收集、使用、维护、保护和披露该信息的做法。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本政策适用于我们通过服务收集的信息,或通过您与网站之间的电子邮件、短信和其他电子消息收集的信息。本政策不适用于我们通过线下方式或通过任何其他方式收集的信息,包括在Picwell或任何第三方运营的任何其他网站上收集的信息,或任何第三方收集的信息,包括通过可能链接到服务或可从服务访问或通过服务访问的任何应用程序或内容收集的信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '请仔细阅读本政策,以了解我们关于您的信息的政策和做法以及我们如何处理这些信息。如果您不同意我们的政策和做法,您可以选择不使用本服务。通过访问或使用本服务,即表示您同意本政策。本政策可能会不时更改(见下文第8条(我们隐私政策的变更))。我们做出更改后,您继续使用本服务即视为接受这些更改,因此请定期查看本政策以了解更新。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '1. 收集的信息类型',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们从服务用户处收集几种类型的信息,包括:(i)已去标识化或匿名化的汇总信息;以及(ii)关于您的互联网连接、您用于访问服务的设备和使用详情的信息。我们直接从您处收集此信息(当您向我们提供时),或在您浏览服务时自动收集。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们在服务上或通过服务收集的信息可能包括您通过填写我们网站上的表格提供的信息、您联系我们时的通信记录和副本、您通过服务进行的交易详情以及您通过服务进行的搜索查询。自动收集的信息可能包括使用详情、互联网协议(IP)地址,以及通过Cookie、网络信标和其他跟踪技术收集的信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Picwell在提供服务时,绝不会要求敏感或个人身份信息,如姓名、电子邮件或邮寄地址、社会保障号码、驾驶执照号码或银行或信用卡的个人识别号码。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '2. 儿童',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '根据1998年《儿童在线隐私保护法》(COPPA),Picwell致力于保护所有儿童的隐私。我们的服务不面向13岁以下的儿童。13岁以下的任何人不得向本服务提供任何信息。我们不会故意收集13岁以下儿童的个人信息。如果您未满13岁,请勿使用本服务或在本服务上提供任何信息。如果我们得知在未经父母同意验证的情况下收集或接收了13岁以下儿童的个人信息,我们将删除该信息。如果您认为我们可能拥有来自或关于13岁以下儿童的任何信息,请通过',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:legal@picwell.com',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'legal@picwell.com',
                  marks: [],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: '与我们联系。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '3. 自动收集的信息',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '当您浏览服务并与之互动时,我们可能会使用自动数据收集技术来收集有关您的设备、浏览行为和模式的某些信息,包括您访问服务的详情以及有关您的计算机和互联网连接的信息。我们自动收集的信息仅为统计数据,不包括个人信息。它帮助我们改进服务并提供更好、更个性化的服务,包括使我们能够:(i)估计我们的受众规模和使用模式;(ii)存储有关您偏好的信息;(iii)协助评估和改进服务;以及(iv)通过在汇总和/或去标识化或匿名基础上使用结果数据来推广我们的服务。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '我们用于自动信息收集的技术可能包括Cookie、网络信标和日志文件。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Cookie',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Cookie是放置在您计算机硬盘上的小文件。您可以通过激活浏览器上的相应设置来拒绝接受浏览器Cookie。但是,如果您选择此设置,您可能无法访问服务的某些部分。除非您已调整浏览器设置使其拒绝Cookie,否则当您将浏览器定向到服务时,我们的系统将发出Cookie。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本服务使用Google Analytics提供的跟踪软件来监控其访问者,该软件使用Cookie来跟踪访问者的使用情况。该软件将在您的计算机硬盘上保存一个Cookie,以便跟踪和监控您对网站的参与和使用,但不会存储、保存或收集个人信息。您可以在以下网址了解Google Analytics的工作原理:',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://policies.google.com/technologies/partner-sites',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'policies.google.com',
                  marks: [],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '网络信标',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '服务页面和我们的电子邮件可能包含称为网络信标的小型电子文件(也称为透明GIF、像素标签和单像素GIF),例如,允许Picwell统计访问过这些页面或打开过电子邮件的用户,以及用于其他相关网站统计。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '日志文件',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '与许多网站一样,本网站使用日志文件。这些文件仅记录网站的访问者——这通常是托管公司的标准程序,也是托管服务分析的一部分。日志文件中的信息包括IP地址、浏览器类型、互联网服务提供商(ISP)、日期/时间戳、引荐/退出页面,以及可能的点击次数。此信息用于分析趋势、管理网站、跟踪用户在网站上的移动以及收集人口统计信息。IP地址和其他此类信息不会与任何个人身份信息相关联。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '请勿跟踪信号',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '请勿跟踪(DNT)信号是通过浏览器发送的信号,告知我们您不希望被跟踪。我们不对DNT信号赋予任何意义,因为目前没有一致的行业合规标准。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '4. 信息的使用和披露',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们使用我们收集的关于您的信息或您向我们提供的信息用于:(i)向您展示我们的服务及其内容;(ii)向您提供您向我们请求的信息、产品或服务;(iii)实现您提供信息的任何其他目的;(iv)履行我们的义务并执行因您与我们之间订立的任何合同而产生的我们的权利;(v)以我们在您提供信息时可能描述的任何其他方式;以及(vi)经您同意的任何其他目的。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '我们可能会无限制地披露有关我们用户的汇总信息以及不识别任何个人身份的信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '5. 您的个人信息',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '我们不会在您使用服务时收集或持有任何可识别您个人身份的信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '6. 加利福尼亚州隐私权',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '根据《加利福尼亚州民法典》第1798.83条,加利福尼亚州居民可以请求有关我们向第三方披露个人信息用于直接营销目的的某些信息。要提出此类请求,请向我们发送电子邮件至',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:legal@picwell.com',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'legal@picwell.com',
                  marks: [],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value:
                '或写信至:Picwell, Inc., Attn: Legal Department, 1900 Market Street, Suite 120, Philadelphia, PA 19103。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '7. 数据安全',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您的信息的安全也取决于您。如果我们已授予您(或您已选择)访问服务某些部分的权限,您有责任对您输入的信息保密。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '不幸的是,通过互联网传输信息并非完全安全。尽管我们尽最大努力保护您的数据(如我们的使用条款中所定义),但我们无法保证传输到服务的您的数据的安全性。任何您的数据的传输均由您自行承担风险。我们不对通过服务包含的任何隐私设置或安全措施的规避负责。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '8. 我们政策的变更',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们的政策是在本页面上发布我们对政策所做的任何更改。如果我们对如何处理您的数据做出重大更改,我们将通过服务主页上的通知通知您。政策的最后修订日期位于页面顶部。您有责任定期访问服务和本隐私政策以检查任何更改。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '9. 第三方链接',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本服务可能包含指向第三方拥有和/或运营的应用程序或网站的链接。我们不对这些实体的隐私做法或内容负责。这些第三方实体有单独的隐私和数据收集做法,因此,我们对它们不承担任何责任或义务。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '10. 联系我们',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您对本政策有任何问题或意见,请通过',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:legal@picwell.com',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'legal@picwell.com',
                  marks: [],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: '向我们发送电子邮件。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    ie_message:
      '我们注意到您正在使用Internet Explorer浏览器。为了给您提供最佳体验,我们建议您使用其他浏览器(如Google Chrome、Firefox或Safari)。',
    privacy_title: '隐私政策',
    button_text: {
      sso_guest: '以访客身份继续 ›',
      sso_login: '使用 SSO 登录',
      employment: '选择答案',
      survey_page: '继续',
      landing_page: '让我们开始吧',
      elig_question: '选择答案',
    },
    privacy_banner_card: 'ALEX中提供的所有数据均为匿名数据。如需了解更多信息,请查看我们的隐私政策。',
    mobile_nav_instruction: '点击任何已解锁的项目即可前后导航。您可以随时更改答案。',
    call_center_login: '输入员工ID:',
    dropdown_instruction: '选择答案',
    landing_headings: {
      mobile: '选择您的{x},终于变得轻松了!',
      desktop: '谁能想到选择您的{x}竟如此简单?',
    },
    illustration_phrases: ['在午休时间。', '保持身体柔韧。', '在广告时段。', '在买拿铁的时候。'],
    survey_heading:
      'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    survey_description: '在开始之前,请回答以下问题,以便我们确定您符合哪些计划的资格。',
    terms_and_conditions: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本使用条款("使用条款")是您与特拉华州公司Picwell, Inc.("Picwell"、"我们"、"我们的"或"我方")之间具有约束力的协议,管辖您对Picwell计划选择和决策支持服务("服务")的访问和使用。我们确认且您确认,本使用条款是Picwell与您之间的协议,而非与任何其他第三方(包括任何移动平台提供商)之间的协议。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Picwell计划选择和决策支持服务使用旨在为未来健康和医疗保健需求创建健康和财务假设的算法。服务的结果基于估算、假设和预测,包括但不限于估计的年度未来成本、医疗保健需求和承保假设。由于依赖此类估算、假设和预测必然存在不确定性,您的实际医疗费用和承保范围可能与服务提供的估算有所不同,甚至可能存在重大差异。服务生成的结果是仅供参考的预测,不提供保证,不应作为做出任何当前或未来决策的依据。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '请在访问或开始使用服务之前仔细阅读使用条款。通过接受本使用条款,无论是通过点击接受或同意,还是通过下载、安装或使用和/或继续使用服务,您确认并声明:(A)您已阅读并理解本使用条款,(B)您年满18周岁或以上,以及(C)您无限制或无保留地接受并同意本使用条款的条款。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '1. 访问和许可',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '1.1 Picwell授予您非独占、不可转让、可撤销的全球范围内使用服务的权利,但须遵守本使用条款("许可")。您授予Picwell非独占的全球范围内使用、复制、存储、传输和显示您的数据的权利,但仅限于提供服务所必需的范围。所有未明确授予您的权利均由Picwell及其许可方保留。就本协议而言,"您的数据"是指您向Picwell提供或提交的任何类型的数据或信息,或在使用服务过程中以电子方式输入的数据或信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '1.2 您同意您不会或不会试图:(i)复制、拷贝、出售、转售、出于任何目的进行商业利用、破坏或干扰服务的任何部分、使用或访问;(ii)将服务用于个人教育以外的任何目的;(iii)直接或间接向任何其他人提供服务访问权限;或(iv)违反任何适用的法律或法规。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '1.3 您对服务的访问和使用负有责任。您将确保您对服务和您的数据的访问和使用始终符合所有适用法律。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '2. 知识产权;您的数据;版权侵权通知程序',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '2.1 服务受知识产权("知识产权")保护,任何未经授权使用服务的行为可能违反此类知识产权、适用法律和本使用条款。Picwell及其许可方拥有知识产权的所有权利、所有权和利益。本使用条款不向您转让或转移任何所有权。如果您向我们提出对服务进行任何类型的添加或其他更改的建议("反馈"),您同意Picwell应拥有该反馈,且您无权获得任何金钱、信用或其他补偿。服务上显示的商标、标识和服务标记,包括但不限于"Picwell",是Picwell或其他第三方的财产。未经Picwell或可能拥有该标记的第三方事先书面同意,您不得使用这些标记。您不得删除或遮盖服务中包含的任何版权声明或其他专有声明。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '2.2 您(而非Picwell)应对您的所有数据承担全部责任,Picwell不对您的任何数据的删除、更正、销毁、损坏、丢失或未能存储负责或承担责任。在使用服务时,您同意不会上传、发布、通过电子邮件传输或以其他方式提供以下任何您的数据:(i)非法或以其他方式令人反感的数据;(ii)对任何人或财产造成伤害、损失或损害风险的数据;(iii)试图以任何方式伤害或利用未成年人的数据;(iv)违反或鼓励任何违反适用法律的行为的数据;或(v)侵犯任何第三方权利的数据。因违约而终止后,您访问或使用您的数据的权利立即终止,Picwell没有义务维护或转发您的任何数据。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '2.3 您理解,您的数据的技术处理和传输(包括可能将您的数据传输到其原籍国以外)对于您使用服务以及通过服务提供的内容可能是必要的,并同意我们拦截和存储您的数据。您理解,您或Picwell可能通过互联网和各种网络传输您的数据,其中只有一部分可能由Picwell拥有和运营。您同意,对于在非Picwell拥有和运营的网络上传输您的数据期间未经授权而丢失、更改、拦截或存储的您的数据的任何部分,Picwell不承担责任。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '2.4 Picwell遵守联邦数字千年版权法("DMCA")。如果您认为服务上包含的任何内容是您的专有作品,并且已以构成侵犯您对该作品的版权的方式被复制,请立即通知Picwell任何此类侵权行为。另请注意,根据DMCA,任何故意实质性虚假陈述材料或活动正在侵权或因错误或错误识别而被删除或禁用的人可能需要承担责任。您的书面通知应发送给我们指定的代理人,如下所示:',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'DMCA投诉:',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Picwell, Inc.',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '收件人:法律部',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '900 Market Street, Suite 120, Philadelphia, PA 19103',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '电子邮件:',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:legal@picwell.com',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'legal@picwell.com',
                  marks: [
                    {
                      type: 'italic',
                    },
                  ],
                  data: {},
                },
              ],
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '所有报告和查询将保密,除非为调查任何涉嫌违规行为和执行本使用条款的条款和条件所必需的范围。在发送版权侵权通知或反通知之前,您可能希望联系律师,以更好地了解您在DMCA和其他适用法律下的权利和义务。以下通知要求旨在遵守我们在DMCA下的权利和义务,不构成法律建议。Picwell将根据DMCA中概述的程序删除侵权内容。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '要向我们提交版权侵权通知,您需要发送书面通信,其中基本包括以下内容(请咨询您的法律顾问或参见美国法典第17编第512(c)(3)条以确认这些要求):(1)被授权代表据称被侵权的专有权所有者行事的人的实体或电子签名;(2)声称已被侵权的受版权保护作品的标识,或者,如果单个在线站点上的多个受版权保护作品由单个通知涵盖,则该站点上此类作品的代表性列表;(3)声称正在侵权或成为侵权活动主体的材料的标识,以及足以允许服务提供商定位该材料的合理充分信息;(4)足以允许服务提供商联系投诉方的合理充分信息,例如地址、电话号码,以及(如果有)电子邮件地址;(5)投诉方善意相信以投诉方式使用材料未经版权所有者、其代理人或法律授权的声明;以及(6)通知中的信息准确的声明,并在伪证处罚下声明,投诉方被授权代表据称被侵权的专有权所有者行事。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '如果您的数据已被删除,您可以选择向我们发送反通知。为使其有效,您的反通知必须是向我们指定代理人提供的书面通信,其中基本包括以下内容(请咨询您的法律顾问或参见美国法典第17编第512(g)(3)条以确认这些要求):(1)订户的实体或电子签名;(2)已被删除或已被禁用访问的材料的标识,以及该材料在被删除或禁用访问之前出现的位置;(3)在伪证处罚下的声明,即订户善意相信该材料是因错误或错误识别要删除或禁用的材料而被删除或禁用的;以及(4)订户的姓名、地址和电话号码,以及订户同意接受地址所在司法管辖区的联邦地区法院管辖的声明,或者如果订户的地址在美国境外,则接受服务提供商可能所在的任何司法管辖区的管辖,并且订户将接受根据第(c)(1)(C)款提供通知的人或该人的代理人的诉讼文书送达。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '3. 期限和终止',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您访问和使用服务的期限应自您接受本使用条款之日起开始,并持续Picwell规定的时间段(与您的福利计划管理员、雇主等的适用基础订阅相关)("期限")。一旦终止,您应停止使用服务。您确认并同意,根据本协议条款,Picwell不会因终止您对服务的访问或使用而对您或任何第三方承担责任。本使用条款第5条和第6条以及本协议对您施加的义务和限制在终止后继续有效。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '4. 免责声明/责任限制',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '4.1 服务可能受到使用互联网和电子通信固有的限制、延迟和其他问题的影响。因此,服务按"原样"和"可用"基础提供。在适用法律允许的最大范围内,PICWELL及其子公司、合作伙伴、关联公司、高级职员、董事、股东、管理人员、成员、员工、代理人和许可方(统称"PICWELL方")否认所有明示或暗示的保证,包括但不限于适销性、特定用途适用性和不侵权的暗示保证。PICWELL方不保证服务将不间断或无错误,缺陷将得到纠正,服务或使服务可用的服务器将不含病毒或其他有害组件,或服务将满足您的适用要求。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '4.2 您明确同意,您使用服务的风险由您自行承担。您将对因通过服务下载任何内容或数据而导致的计算机系统或移动设备的任何损坏或数据丢失承担全部责任。我们保留随时限制或终止您对服务或其任何功能或部分的访问的权利。PICWELL方对任何内容、数据或个性化设置的删除、错误传递或未能存储不承担任何责任。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '4.3 您理解并同意,PICWELL方不会因以下原因对您承担任何间接、附带、特殊、后果性或惩戒性损害赔偿责任,包括但不限于利润损失、商誉、使用、数据或其他无形损失的损害赔偿(即使PICWELL方已被告知可能发生此类损害):(i)您使用或访问服务或无法使用或访问服务;(ii)因通过或从服务购买或获得的任何商品、数据、信息或服务或收到的消息或进行的交易而产生的替代商品和服务的采购成本;(iii)未经授权访问或更改您的传输或数据;或(iv)与服务有关的任何其他事项。在任何情况下,PICWELL的总累计责任不得超过您在引起损害赔偿索赔的事件发生前十二(12)个月期间为使用服务而向PICWELL支付(且未以其他方式退还给您)的金额。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '5. 赔偿和免责',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '5.1 您同意就因您违反本使用条款或与您使用服务相关的任何其他行为而产生或与之相关的所有损失、费用、损害赔偿和成本(包括合理的律师费),对PICWELL方进行赔偿、辩护并使其免受损害。您的赔偿义务包括但不限于因您的任何数据而产生的索赔,以及因通过您的注册信息访问服务的任何其他人或实体的作为或不作为而产生的任何索赔,无论是经您许可还是由于您未能使用合理的安全措施。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '5.2 除本协议规定外,Picwell不直接参与您与使用服务的健康和健康福利提供商("提供商")之间的实际交易。由于我们不参与您与提供商之间的实际直接交易,如果您与提供商发生争议,您免除PICWELL方因此类争议而产生或以任何方式与之相关的各种已知和未知、怀疑和未怀疑、披露和未披露的索赔、要求和损害赔偿(实际和后果性)。如果您是加利福尼亚州居民,您放弃加利福尼亚州民法典第1542条规定授予的任何和所有权利和利益,该条规定如下:',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '一般免责不延伸至债权人或免责方在执行免责时不知道或不怀疑存在对其有利的索赔,并且如果其知道该索赔,将对其与债务人或被免责方的和解产生重大影响。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '使用条款的修改',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们可能会自行决定不时修订和更新本使用条款。所有更改在发布后立即生效,或在法律要求的情况下在发布后最多三十(30)天后生效,并适用于此后对服务的所有访问和使用。您在发布对本使用条款的更改后继续使用服务意味着您接受并同意此类更改。您有责任定期查看本使用条款的更改,因为这些更改对您具有约束力。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '禁令救济',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您违反本使用条款可能会对我们造成立即且不可弥补的损害,对此可能没有充分的法律补救措施,因此,您同意我们有权获得衡平法救济,以强制您停止并终止通过服务获得的信息的所有未经授权的使用、评估和披露,这是对法律或衡平法上可获得的任何其他补救措施的补充。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '适用法律',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '本使用条款应受特拉华州法律和适用的美国联邦法律管辖。统一计算机信息交易法、联合国国际货物销售合同公约以及任何司法管辖区的法律选择规则不适用于本使用条款。与本使用条款有关的任何法律诉讼或程序应在特拉华州新卡斯尔县的州或联邦法院提起,各方特此服从此类法院的专属属人管辖权,并放弃与地点或不方便法院有关的任何抗辩。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '不放弃可分割性',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '放弃本使用条款任何条款的任何违约并不是放弃此类违约的任何重复,并且不会以任何方式影响本使用条款的任何其他条款或条件。我们不会因未在每种可能适用的情况下执行本使用条款的任何条款而放弃任何权利。如果本使用条款的任何条款被认定为不可执行,则不会影响其余条款的有效性或可执行性,并将由最接近不可执行条款所依据意图的可执行条款替代。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '可转让性',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '我们可以随时全部或部分转让我们的权利并委托我们在本使用条款下的义务,无需通知。未经我们事先书面同意,您不得全部或部分转让、再许可或以其他方式转让您在本使用条款下的权利或义务给任何其他人。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '关系',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '本协议不在您与我们之间建立任何合伙、合资、雇佣、特许经营或代理关系。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-2',
          content: [],
          data: {},
        },
      ],
    },
    tooltips: {
      name: {
        text: '我们使用这些问题来确定您有资格获得哪些计划',
        title: '资格',
        underline: '资格',
      },
    },
    terms_and_policy_disclaimer: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '点击"开始使用",即表示您理解并同意',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '服务条款',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '和',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '隐私政策',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    logo_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/picwell_logo.svg',
    landing_arrow: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/cartoon-arrow.svg',
    do_not_sell_my_info_text: '您的隐私选择',
    landing_illustrations_links: [
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/sketch-landing-new-1.svg',
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/sketch-landing-new-3.svg',
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/sketch-landing-new-2.svg',
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/sketch-landing-new-4.svg',
    ],
    contentful_name: 'Eligibility Section (DEFAULT DO NOT CHANGE)',
    service_options: {
      benefits: '福利',
      insurance: '健康保险',
    },
    terms_and_policy_disclaimer_sso: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '点击"使用 SSO 登录"或"以访客身份继续",即表示您理解并同意',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '服务条款',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '和',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '隐私政策',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    name: '资格条件',
    survey_questions: {
      zip5: {
        heading: '您的5位数邮政编码是什么?',
        placeholder: '邮政编码',
      },
      fips5: {
        instructions: {
          complete: '选择县',
          incomplete: '请在上方输入邮政编码',
        },
      },
      is_california_resident: {
        heading: '您是伟大的加利福尼亚州的居民吗?',
        options: {
          No: '否',
          Yes: '是',
        },
      },
      is_full_time_or_part_time: {
        heading: '您是全职还是兼职?',
        options: {
          'Full-Time': '全职',
          'Part-Time': '兼职',
        },
      },
    },
  },
};
